import { Modal } from 'farmhub-ui-core';
import styled, { css } from 'styled-components';

import { overlay } from 'styled';

export const Wrapper = styled.div``;

export const CModal = styled(Modal)<{ hideIconClose: boolean }>`
  ${props => props.hideIconClose && `.ant-modal-close { display: none;}`};
`;

export const ModalStyles = css`
  .ant-modal-header {
    display: none !important;
  }

  .ant-modal-body {
    overflow: scroll;
    padding: 24px 36px !important;

    ${overlay}
  }
`;

export const WrapperContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const WrapperIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 112px;
  height: 112px;
  background: ${props => `${props.theme.colors.primary.main}18`};
  color: ${props => props.theme.colors.primary.main};
  border-radius: 50%;
  flex-shrink: 0;

  position: relative;
`;
